export default __webpack_public_path__ + "static/media/P500_CE.63e1131a.pdf";